<template>
    <access-denied v-if="accessDenied" title="rota" />
    <div id="main" v-else>
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ !isUpdate ? $t('adicionar') + ' ' + $t('rota') : $t('rota') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">
                                        {{ $t('promotor') }}
                                    </a>
                                </li>
                                <li>
                                    <a class="a-inativo">
                                        {{ $t('cadastros') }}
                                    </a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'rota-list' })">
                                        {{ $t('rota') }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{
                                            $route.params.id
                                                ? $route.params.id
                                                : $t('adicionar') + ' ' + $t('rota')
                                        }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: `rota-list` })"
                        >
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>
                <template v-if="isUpdate">
                    <ul class="nav nav-tabs nav-tabs-children">
                        <li
                            v-for="(aba, i) in abas"
                            :key="i"
                            v-show="permissao.read"
                            :class="{ active: abaSelecionada == i }"
                            @click="changeTab(i)"
                        >
                            <a data-toggle="tab">{{ $t(aba) }}</a>
                        </li>
                    </ul>

                    <!-- CONJUNTO DE ABAS - MOBILE -->
                    <b-dropdown aria-role="list" class="mobile-tab-list">
                        <div slot="trigger" class="mobile-tab">
                            <span class="mobile-tab-text">
                                {{ $t(abas[abaSelecionada]) }}
                            </span>
                            <em class="mdi mdi-chevron-down"></em>
                        </div>

                        <b-dropdown-item
                            class="mobile-tab-list-item"
                            :class="{ active: abaSelecionada == i }"
                            aria-role="listitem"
                            v-for="(aba, i) in abas"
                            v-show="permissao.read"
                            :key="i"
                            @click="changeTab(i)"
                        >
                            {{ $t(aba) }}
                        </b-dropdown-item>
                    </b-dropdown>
                </template>

                <DadosCadastrais
                    ref="DadosCadastrais"
                    v-if="!newToEdit && permissao.read"
                    v-show="abas[abaSelecionada] == 'dados-cadastrais'"
                    :isUpdate="isUpdate"
                    :permissao="permissao"
                    @isChanged="isChanged = $event"
                    @rota="rota = $event"
                />

                <Itinerario
                    ref="Itinerario"
                    v-if="permissao.read && isUpdate && rota != null"
                    v-show="abas[abaSelecionada] == 'itinerario'"
                    :rota="rota"
                    :permissao="permissao"
                    @isChanged="isChanged = $event"
                />

                <container-loader v-if="isUpdate && rota == null && !$store.getters.isLoading" />
            </div>
        </div>
    </div>
</template>

<script>
import DadosCadastrais from '@/components/promotor/rota/abas/DadosCadastrais.vue';
import Itinerario from '@/components/promotor/rota/abas/Itinerario.vue';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    beforeRouteLeave(to, from, next) {
        if (from.name == 'rota-new' && to.name == 'rota-edit') {
            this.isUpdate = true;
            this.newToEdit = true;
            setTimeout(() => {
                this.newToEdit = false;
            }, 500);
        }
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        ContainerLoader,
        DadosCadastrais,
        Itinerario,
    },
    data() {
        return {
            accessDenied: false,
            newToEdit: false,
            isChanged: false,
            abaSelecionada: 0,
            abas: ['dados-cadastrais', 'itinerario'],
            abasAbertas: {},
            rota: null,
            isUpdate: false,
            permissao: {},
            debounceTab: null,
        };
    },
    mounted() {
        if (
            this.$route.query.abaSelecionada &&
            this.abas.includes(this.$route.query.abaSelecionada)
        ) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada), true);
        }
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'rotas');

        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.accessDenied = true;
            return;
        }

        this.abasAbertas['dados-cadastrais'] = true;
    },
    methods: {
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        changeTab(i, byRoute = false) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;

            if(!byRoute) {
                clearTimeout(this.debounceTab);
                this.debounceTab = setTimeout(() => {
                    // recria objeto de query da url com novo valor para tipo negócio
                    let query = {};
                    if (this.$route.query) {
                        query = { ...this.$route.query };
                        if (query.abaSelecionada) delete query.abaSelecionada;
                    }
    
                    query.abaSelecionada = this.abas[this.abaSelecionada];
                    // muda a url
                    this.$router.push({ query: query });
                }, 400);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import './mixins.scss';
.column {
    @include default-size-column;
}

#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
        .nav-tabs-children {
            margin-bottom: 20px;
            li > ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }

        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: '';
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                & ~ i {
                    color: $primary-color-click;
                }
            }
        }
    }
}

.nova-rota .center {
    width: 100%;
    left: 0;
    transform: translateX(0);
    margin: 0;
    box-sizing: border-box;
    padding-right: 20px;
    position: initial;
    padding-bottom: 60px;
}

.nova-rota {
    .form-buttons {
        position: absolute;
        top: 20px;
        right: 20px;
        display: flex;
        justify-content: flex-end;
    }

    .form-buttons {
        right: 0px;
    }

    .form-buttons .save-btn,
    .form-buttons .delete-btn,
    .getlocation,
    .adicionar-promotor .save-btn,
    .select-lps .save-btn {
        color: $sovis-white;
        font-size: 12px;
        text-align: center;
        padding: 15px 40px;
        border: none;
        border-radius: 6px;
        font-weight: 600;
        margin-left: 20px;
        @include gradient-button();
    }
    .adicionar-promotor .save-btn {
        background: $darker-bg-color;
        color: $darker-gray-color;
        box-shadow: none;
        position: relative;
        top: 30px;
    }
    .select-lps {
        position: relative;

        .save-btn {
            background: $darker-bg-color;
            color: $darker-gray-color;
            box-shadow: none;
        }
    }
    .form-buttons .delete-btn {
        right: 225px;
        color: $darker-gray-color;
        @include exclude-button();
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
